var Backbone = require('backbone'),
    $ = window.jq = require('jquery'),
    scope = require('scope'),
    helpers = require('../lib/helpers'),
    Uri = require('urijs');
    
function init() {
    var Route = require('./Main'),
        root = this.root = new Uri($('#cotacao-appviewbox').attr('data-base'));
    new Route();

    Backbone.history.start({
        pushState: true,
        hashChange: false,
        root: root.pathname()
    });

    $('#cotacao-appviewbox').on('click', 'a:not([data-bypass])', function (event) {
        var link = event.currentTarget;
        // Only anchors tags
        if (link.tagName.toUpperCase() !== 'A')
            return;

        if (link.target === '_blank') {
            return;
        }

        // Middle click, cmd click, and ctrl click should open
        // links in a new tab as normal.
        if ( event.which > 1 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey )
            return;

        // Ignore cross origin links
        if ( location.protocol !== link.protocol || location.hostname !== link.hostname )
            return;

        // Ignore event with default prevented
        if (event.isDefaultPrevented())
            return;

        event.preventDefault();

        scope.metrics.stopScroll();

        setTimeout(function(){
            navigate(link.href)
        }, 1);
    });

    function navigate(url, replace, noAnchor) {
        url = url.replace('./', '');

        var full = root.toString(), fragment = (url + '/' === full) ? '' : url.replace(full,  ''),
            parts = fragment.split('#');
        var matchs = Backbone.history.navigate(parts[0], {trigger: true, replace: replace});
        
        if (parts[1]) {
            window.history.replaceState({}, document.title, url);
            !noAnchor && helpers.anchor('#' + parts[1]);
        } else if (window.location.href.indexOf('#') > -1) {
            var uri = window.location.href.substr(0, window.location.href.indexOf('#'));
            window.history.replaceState({}, document.title, uri);
            !noAnchor && helpers.anchor(0);
        } else if (typeof matchs  === 'undefined') {
            !noAnchor && helpers.anchor(0);
        } else {
            !noAnchor && helpers.anchor(0);
        }

        // setTimeout(function () {
        //     try{
        //         scope.metrics.startScroll(parts[1] || parts[0] || '');
        //     }catch(e){
        //         scope.metrics.resumeScroll();
        //     }
        // }, 1050)

        scope.app.trigger('routed');
    }
    scope.app.navigate = navigate;    
}
module.exports = init;



// WEBPACK FOOTER //
// ./resources/scripts/routes/init.js